export class Catalog {
  id!: string;
  name!: string;
  content_count!: number;
  updated_at!: string;
  updated_by!: string;

  constructor(catalog: Partial<Catalog | null>) {
    this.id = '';
    this.name = '';
    Object.assign(this, catalog);
  }
}
